<div class="form-field" padding-y>
  <div *ngIf="icon && !label" class="form-field__input-icon">
    <ng-content select="rt-icon"></ng-content>
  </div>

  <div *ngIf="label" class="form-field__input-label">
    <ng-content select="rt-label"></ng-content>
    <div
      *ngIf="!hideRequiredBadge && isRequired() && !isControlStatus('DISABLED')"
      class="badge-required"
    >
      <span>*</span>
    </div>
    <ng-content select="rt-icon-help"></ng-content>
  </div>

  <div class="form-field__input-wrapper">
    <ng-content></ng-content>
  </div>

  <div class="form-field__input-button">
    <ng-content select="rt-button, rt-icon-button"></ng-content>
  </div>

  <div class="form-field__input-spinner">
    <ng-content select="rt-spinner"></ng-content>
  </div>

  <div *ngIf="hints.length > 0 && !errors.length" class="form-field__hint-wrapper">
    <span *ngFor="let hint of hints; trackBy: trackByError" class="hint">{{ hint }}</span>
  </div>

  <div *ngIf="errors.length > 0 && !isValidationForced" class="form-field__error-output">
    <span *ngFor="let error of errors; trackBy: trackByError" class="error">{{ error }}</span>
  </div>
</div>
